import localforage from 'localforage'

//[localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE]
const localDataStore = localforage.createInstance({
    name: md5(window.location.hostname),
    storeName: md5(window.app),
    description: window.webName,
    driver: localforage.INDEXEDDB
})

/** 设置数据 */
const set = (key, value,time=0) => {
    return new Promise((resolve, reject) => {
        if(!value){
            resolve(false)
        }
        const raw = {
            value:JSON.parse(JSON.stringify(value)),
            time:time===0?time:new Date().getTime()+time*60000,
        };  // 脱响应式
        localDataStore.setItem(key, raw).then(()=>{
            resolve(true)
        })
    })
}

/** 获取数据 */
const get = (key) => {
    return new Promise((resolve, reject) => {
        localDataStore.getItem(key).then((data) => {
            if(!data){
                resolve(false);
                return;
            }
            if(data.time !== 0 && data.time < new Date().getTime()){
                resolve(false);
                return;
            }
            resolve(data.value)
        })
    })
}

/** 删除数据 */
const remove = (key) => {
    return new Promise((resolve, reject) => {
        localDataStore.removeItem(key).then(()=>{
            resolve(true)
        })
    })
}

/** 清空数据 */
const clear = () => {
    return new Promise((resolve, reject) => {
        localDataStore.clear().then(()=>{
            resolve(true)
        })
    })
}

export default {
    set,
    get,
    remove,
    clear
}